var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.item.date) +
          " –\n  " +
          _vm._s(_vm.item.what) +
          " " +
          _vm._s(_vm.item.action) +
          " –\n  "
      ),
      _vm.affectingFinalPayment
        ? [_vm._v("\n    Final –\n  ")]
        : _vm.affectingDepositPayment
        ? [_vm._v("\n    Deposit –\n  ")]
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.responsible) + "\n  "),
      _vm._l(_vm.to, function (item, key, index) {
        return _c(
          "p",
          { key: index, staticClass: "change" },
          [
            _c("strong", [_vm._v("\n      " + _vm._s(key) + ":\n    ")]),
            _vm._v(" "),
            _vm.from[key]
              ? [_vm._v('\n      "' + _vm._s(_vm.from[key]) + '"\n    ')]
              : _vm._e(),
            _vm._v(" "),
            _vm.to
              ? [
                  _vm.from[key] ? _c("strong", [_vm._v("to")]) : _vm._e(),
                  _vm._v(' "' + _vm._s(item) + '"\n    '),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }